import React from 'react';

const OrderStatusInProgress = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="#00CE64"
        d="M19.355 11.613H6.57a.774.774 0 1 0 0 1.548h8.139v2.537c0 .868.418 1.565 1.252 2.089-.818.427-1.227 1.107-1.228 2.039v2.626H3.097a1.548 1.548 0 0 1-1.549-1.549V3.871c0-.855.694-1.548 1.549-1.548h14.71c.855 0 1.548.693 1.548 1.548v7.742zm0 5.608v1.107l-.59-.541.59-.566zM6.57 9.29h7.495a.774.774 0 1 0 0-1.55H6.571a.774.774 0 0 0 0 1.55zm0 7.741h5.419a.774.774 0 1 0 0-1.548H6.57a.774.774 0 0 0 0 1.548z"
      />
      <path
        fill="#8AE8B8"
        d="M22.098 15.715v-1.223l.029-1.33h-5.843l-.026 1.33v1.206c0 .523.32 1.012.852 1.306l1.338.746-1.352.79c-.51.298-.812.776-.812 1.286v2.625h5.843V19.84c0-.522-.32-1.011-.852-1.305l-1.34-.747 1.35-.791c.509-.296.81-.773.813-1.28z"
      />
    </g>
  </svg>
);

export default OrderStatusInProgress;
